import { render } from "./UserEnrolProjectListComponent.vue?vue&type=template&id=0308af1a"
import script from "./UserEnrolProjectListComponent.vue?vue&type=script&lang=js"
export * from "./UserEnrolProjectListComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__